import {
  ButtonV2,
  OdinIcon,
  Popover,
  PopoverContent,
  PopoverTrigger,
  TabView,
  TabViewPanel,
} from '@myosh/odin-components';
import { memo, useCallback, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DisplayFilterTab, { type DisplayFilterTabRef } from './display-filter-tab.component';

function FilterOverlay() {
  const { t } = useTranslation();
  const [isFilterOverlayOpen, setIsFilterOverlayOpen] = useState(false);

  const displayFilterTabRef = useRef<DisplayFilterTabRef>(null);

  const closeFilterOverlay = useCallback(() => {
    setIsFilterOverlayOpen(false);
  }, []);

  const handleSave = useCallback(() => {
    displayFilterTabRef.current?.save();
    closeFilterOverlay();
  }, []);

  return (
    <Popover open={isFilterOverlayOpen} onOpenChange={setIsFilterOverlayOpen}>
      <PopoverTrigger
        render={<ButtonV2 variant="ghost" size="icon" aria-label={t('filter')} data-cy="filter-overlay-trigger" />}
      >
        <OdinIcon icon="Filter" className="size-5" />
      </PopoverTrigger>
      <PopoverContent align="start" data-cy="filter-overlay-panel">
        <TabView className="hover:text-primary text-muted-foreground mr-4 cursor-pointer" activeIndex={0}>
          <TabViewPanel header="Display">
            <DisplayFilterTab ref={displayFilterTabRef} />
          </TabViewPanel>
        </TabView>
        <ButtonV2 variant="outline" className="w-full" data-cy="filter-overlay-apply-button" onClick={handleSave}>
          Apply
        </ButtonV2>
      </PopoverContent>
    </Popover>
  );
}

export default memo(FilterOverlay);
